import React, { ReactNode } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { routeNames } from "utils";

const PageWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const TopNav = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  border-bottom: 1px solid #f0f0f0;

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

const Logo = styled.img`
  height: 32px;
`;

const LanguageSelector = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  font-size: 0.875rem;
  color: #666;
  font-family: "Manrope", sans-serif;

  svg {
    font-size: 1rem;
  }
`;

const Container = styled.div`
  width: 100%;
  max-width: 500px;
  margin: 2rem auto;
  padding: 0 1rem;
  font-family: "Manrope", sans-serif;

  @media (max-width: 768px) {
    margin: 1.5rem auto;
    width: 90%;
  }

  @media (max-width: 480px) {
    margin: 1rem auto;
    width: 90%;
  }
`;

const Title = styled.h1`
  font-size: 1.5rem;
  color: #000;
  margin-bottom: 0.5rem;
  font-weight: 500;

  @media (max-width: 480px) {
    font-size: 1.25rem;
  }
`;

const Description = styled.p`
  color: #666;
  font-size: 0.875rem;
  margin-bottom: 0.5rem;

  @media (max-width: 480px) {
    font-size: 0.8125rem;
  }
`;

interface AuthLayoutProps {
  children: ReactNode;
  title: string;
  description?: string;
}

export const AuthLayout: React.FC<AuthLayoutProps> = ({
  children,
  title,
  description,
}) => {
  return (
    <PageWrapper>
      <TopNav>
        <Link to="#" onClick={() => window.location.href = routeNames.home}>
          <Logo src="/assets/logo.png" alt="compellingcandidature" />
        </Link>
        {/* <LanguageSelector>
          English
          <IoIosArrowDown />
        </LanguageSelector> */}
      </TopNav>

      <Container>
        <Title>{title}</Title>
        {description && <Description>{description}</Description>}
        {children}
      </Container>
    </PageWrapper>
  );
};
